// src/services/api/orderAssignments.js
import { apiClient } from './base';

export const assignOrders = async (assignmentData) => {
  try {
    const response = await apiClient.post('/order-assignments/assign', assignmentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveAssignmentRules = async (rulesData) => {
  try {
    const response = await apiClient.post('/order-assignments/rules', rulesData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAssignmentRules = async (shopId) => {
  try {
    const response = await apiClient.get(`/order-assignments/rules/${shopId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMyWorkQueue = async (params = {}, { signal } = {}) => {
  try {
    const response = await apiClient.get('/order-assignments/my-queue', { params, signal });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAssignmentStats = async (params = {}) => {
  try {
    const response = await apiClient.get('/order-assignments/stats', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShopAssignmentStats = async (shopId) => {
  try {
    const response = await apiClient.get(`/order-assignments/shop-stats/${shopId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reassignOrders = async (reassignData) => {
  try {
    const response = await apiClient.post('/order-assignments/reassign', reassignData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Assign a list of already-created order IDs to the given users (round-robin).
 * Called after a successful bulk-create when the user has chosen manual assignment.
 *
 * @param {{ orderIds: number[], userIds: number[], shopId: number }} payload
 */
export const bulkAssignCreatedOrders = async ({ orderIds, userIds, shopId }) => {
  try {
    const response = await apiClient.post('/order-assignments/bulk-assign-created', {
      orderIds,
      userIds,
      shopId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWorkQueueDashboardStats = async (params = {}) => {
  try {
    const response = await apiClient.get('/order-assignments/dashboard-stats', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};